'use client'

import { cn } from '@/lib/utils'
import { isBlockWithFormFields } from '@/types/contentful/halfHalfBlockType'

import { containerVariants, sectionVariants, type HalfHalfBlockLayoutVariant } from './HalfHalfBlock.styles'
import { HalfHalfBlockAction } from './HalfHalfBlockAction'
import { HalfHalfBlockCopy } from './HalfHalfBlockCopy'
import { HalfHalfBlockMedia } from './HalfHalfBlockMedia'
import { CmsContainer } from '../CmsContainer/CmsContainer'

import type { HalfHalfBlockFields } from '@/types/contentful/halfHalfBlockType'

export const HalfHalfBlock = (props: HalfHalfBlockFields & { isFirst?: boolean }) => {
  const { layout = 'Left Image', mobileLayout = 'Image Top', content, backgroundColor, contained, topPadding = 'lg', bottomPadding = 'lg', isFirst } = props

  const fields = content?.fields
  const withForm = isBlockWithFormFields(fields)

  const image = fields?.image
  const video = fields?.video
  const title = fields?.title
  const subtextRichText = fields?.subtextRichText

  const titleSize = withForm ? fields.titleSize : undefined
  const formEntry = withForm ? fields.form : undefined
  const actionButton = !withForm && fields && 'actionButton' in fields ? fields.actionButton : undefined

  return (
    <section
      data-name="half-half-block"
      className={sectionVariants({
        backgroundColor: backgroundColor as 'White' | 'Grey' | 'None',
        contained,
        topSpacing: false,
        bottomSpacing: false,
      })}
    >
      <CmsContainer topPadding={topPadding} bottomPadding={bottomPadding}>
        <div
          className={containerVariants({
            layout: layout as HalfHalfBlockLayoutVariant,
            mobileLayout: mobileLayout as HalfHalfBlockLayoutVariant,
            contained,
            blockBackgroundColor: contained ? 'White' : 'None',
          })}
        >
          <div className="flex-1">
            <HalfHalfBlockMedia image={image} video={video} priority={isFirst} />
          </div>

          <div className={cn('text flex flex-1 flex-col justify-center md:mt-0', mobileLayout == 'Image Top' ? 'mt-6' : 'mb-6')}>
            <HalfHalfBlockCopy title={title} titleSize={titleSize} subtextRichText={subtextRichText} />
            <HalfHalfBlockAction actionButton={actionButton} form={formEntry} />
          </div>
        </div>
      </CmsContainer>
    </section>
  )
}
